<div class="flex flex-col gap-4">
  <div class="flex flex-col gap-1 pb-3 border-b border-gray-100">
    <span class="text-sm text-gray-500">Saisie directe de la liste des soumissionnaires</span>
  </div>

  <div class="max-h-[60vh] overflow-y-auto pr-1">
    <sm-multi-form-accordion *ngIf="accordionObject" [accordionObject]="accordionObject"></sm-multi-form-accordion>
  </div>

  <div class="flex justify-end gap-2 mt-4 pt-3 border-t border-gray-200">
    <button pButton type="button" class="p-button-secondary" label="Annuler" (click)="cancel()"></button>
    <button pButton type="button" class="p-button-success" label="Soumettre" (click)="submit()"></button>
  </div>
</div>
